import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M3.667 5.99a2.322 2.322 0 0 1 2.322-2.323h32.022a2.322 2.322 0 0 1 2.323 2.322v32.022a2.322 2.322 0 0 1-2.323 2.323H5.99a2.322 2.322 0 0 1-2.322-2.323V5.99z",
      stroke: "currentColor",
      "stroke-width": "2.322"
    }, null, -1),
    _createElementVNode("path", {
      d: "M22 14.514v14.972M14.514 22h14.972",
      stroke: "currentColor",
      "stroke-width": "2.322",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }